import axios from "axios";
import Vue from "vue";
import router from "./router";
import { http, base } from "@/api/config.api.js";
import { API_CONST } from "@/api/api.js";

// 文书查看的地址
export const writURL =
  "http://192.168.102.234:7070/REPORT/reportJsp/showReport.jsp";
// 跳转原系统
export const originalAdress =
  "http://192.168.102.136:8080/default/com.hymake.common.widget.system.login.novaLogin.flow";
// bucketName
export const bucketName = "hymake-nova";

http.interceptors.request.use(function (res) {
  //console.log( res.url)
  if (res.url.indexOf("dust") != undefined && res.url.indexOf("dust") >= 0) {
    res.headers.token = localStorage.getItem("atmosToken");
  } else {
    res.headers.token = localStorage.getItem("token");
  }
  return res;
});

function parseUrl(url) {
  let str = JSON.stringify(url);
  if (str.indexOf("limit") >= 0 && str.indexOf("%") >= 0) {
    alert("该搜索中含有%，无法搜索！");
    str = str.replace(/%/g, "");
  }
  if (str.indexOf("limit") >= 0 && str.indexOf("/") >= 0) {
    alert("该搜索中含有/，无法搜索！");
    str = str.replace(/\//g, "");
  }
  return encodeURIComponent(encodeURIComponent(str));
}
//环境监测
export const dust = {
  dusts: (params) => {
    let base = API_CONST.atmos;
    {
      return http.get(base + "/dust/dusts/" + params).then((res) => res.data);
    }
  },
  lastDust: (params) => {
    let base = API_CONST.atmos;
    {
      return http.get(base + "/dust/lastDust").then((res) => res.data);
    }
  },
  getToken: () => {
    let base = API_CONST.atmos;
    return http
      .get(base + "/common/getToken/A0000002/E33F957EA1A94CE584ECE5D4192A8A99")
      .then((res) => res.data);
  },
};

//施工项目考评
export const ProjectCheck = {
  //记分告知单详细
  spotCheckScoreNotice: (params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    // console.log(JSON.stringify(params));
    {
      return http
        .get(
          base + "/spotCheckScoreNotice/getScoreNoticeInfo/" + parseUrl(params)
        )
        .then((res) => res.data);
    }
  },
  //动态监管抽查抽测查看
  getSpotcheckdyView: (params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    // console.log(JSON.stringify(params));
    {
      return http
        .get(base + "/spotCheckdy/getSpotcheckdyView/" + parseUrl(params))
        .then((res) => res.data);
    }
  },
  //项目月考评相关
  proMonthCheck: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/safetyProjectMonthEval";
    // console.log(JSON.stringify(params))
    switch (method) {
      //施工单位（月考评-搜索）
      case "queryAll_query":
        {
          return http
            .get(nowBase + "/unitInfos" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      //项目经理（月考评-登记）
      case "queryAll_regist":
        {
          return http
            .get(
              nowBase +
                "/safetyProjectMonthEvals" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      //总监（月考评-盖章）
      case "queryAll_sign":
        {
          return http
            .get(
              nowBase +
                "/safetyProjectMonthEvalsByStatus" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "queryItem":
        {
          return http
            .get(nowBase + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "update":
        {
          return http.post(nowBase + "/update", params).then((res) => res.data);
        }
        break;
      case "withdraw":
        {
          return http
            .post(nowBase + "/pmUndoSubmit", params)
            .then((res) => res.data);
        }
        break;
      //评分明细表（弃用）
      case "monthEvalDetails":
        {
          return http
            .get(
              base +
                "/safetyProjectMonthEvalDetail/monthEvalDetails" +
                pageInfo +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
    }
  },
  // 项目季考评
  proQuarterCheck: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/safetyProjectQuarterEval";
    // console.log(JSON.stringify(params))
    switch (method) {
      case "queryAll_regist":
        {
          return http
            .get(nowBase + "/unitInfos" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "queryAll_query":
        {
          return http
            .get(
              nowBase +
                "/safetyProjectQuarterEvals" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "queryItem":
        {
          return http
            .get(nowBase + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "update":
        {
          return http.post(nowBase + "/update", params).then((res) => res.data);
        }
        break;
    }
  },
  //竣工考评
  proFinishedCheck: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/safetyProjectFinishedEvalsp";
    // console.log(method)
    // console.log(JSON.stringify(params))
    switch (method) {
      // safetyProjectFinishedEvalsp/safetyProjectFinishedEvalsByStatus/20/1/jsonStr
      case "queryAll_regist":
        {
          return http
            .get(
              nowBase +
                "/safetyProjectFinishedEvalsps" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "queryAll_query":
        {
          return http
            .get(nowBase + "/unitInfos" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "queryAll_sign":
        {
          return http
            .get(
              nowBase +
                "/safetyProjectFinishedEvalsByStatus" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "queryAll_publicity":
        {
          return http
            .get(
              nowBase +
                "/selectProjectResultPublicity" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "queryAll_inform":
        {
          return http
            .get(
              nowBase +
                "/selectProjectResultInform" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "query_materials":
        {
          return http
            .get(
              nowBase +
                "/getProjectEvalRelateData" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "getZrsg":
        {
          return http
            .get(nowBase + "/getZrsg" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "getTbpp":
        {
          return http
            .get(nowBase + "/getTbpp" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "getXzch":
        {
          return http
            .get(nowBase + "/getXzch" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "getStop":
        {
          return http
            .get(
              nowBase +
                "/selectGoodProjectSpotCheckNotice" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "getActScoreNotices":
        {
          return http
            .get(
              nowBase +
                "/getActScoreNotices" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "queryItem":
        {
          return http
            .get(nowBase + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "update":
        {
          return http.post(nowBase + "/update", params).then((res) => res.data);
        }
        break;
      case "delete":
        {
          return http
            .delete(nowBase + "/delete/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "sth":
        {
          return http
            .get(
              base +
                "/safetyProjectFinishedEvalObjection/unitInfos" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "sthDetail":
        {
          return http
            .get(
              base + "/safetyProjectFinishedEvalObjection/" + parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
    }
  },
};

//施工企业考评
export const UnitCheck = {
  //施工企业基本信息
  //http://192.168.102.234:9090/NOVA/rest/safetyConstructionLicense/isUnitEval/%7Blimit:%7B%7D,userId:%2215622043X%22%7D
  baseInfor: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/safetyConstructionLicense";
    // console.log(JSON.stringify(params))
    switch (method) {
      case "unitInfos":
        {
          return http
            .get(nowBase + "/unitInfos" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "getUnitBaseInfo":
        {
          return http
            .get(
              base +
                "/unitInfo/getUnitBaseInfo" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "updateRecord":
        {
          return http
            .get(nowBase + "/" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "isUnitEval":
        {
          return http
            .get(nowBase + "/isUnitEval" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "add":
        {
          return http
            .post(nowBase + "/add" + pageInfo + "/", params)
            .then((res) => res.data);
        }
        break;
      case "update":
        {
          return http
            .post(nowBase + "/update" + pageInfo + "/", params)
            .then((res) => res.data);
        }
        break;
      case "delete":
        {
          return http
            .delete(nowBase + "/delete" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
    }
  },
  //施工企业自评（填报）
  //addSave: data => { return http.post(base + "/safetyUnitSelfEval/saveUnitSelfEval/",data).then(res => res.data) },
  evalSelf: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/safetyUnitSelfEval";
    // console.log(JSON.stringify(params))
    switch (method) {
      case "queryList":
        {
          return http
            .get(
              nowBase +
                "/selectUnitSelfEvalSearch" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "queryDetail":
        {
          return http
            .get(
              nowBase +
                "/getDetailForInsert" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "save":
        {
          return http
            .post(nowBase + "/saveUnitSelfEval", params)
            .then((res) => res.data);
        }
        break;
      case "delete":
        {
          return http
            .delete(nowBase + "/delete/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "getCurrentEvalDates":
        {
          return http
            .get(
              nowBase +
                "/getCurrentEvalDates" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
    }
  },
  //施工企业考评(填报)
  evalFill: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    // params["userId"] = '15622043X';
    let nowBase = base + "/safetyUnitEvaluationsp";
    // console.log(JSON.stringify(params))
    switch (method) {
      case "queryList":
        {
          return http
            .get(
              base +
                "/safetyConstructionLicense/unitInfos" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "getMainPerson":
        {
          return http
            .get(
              base +
                "/safetyConstructionLicense/getMainPerson" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "evalueSave":
        {
          return http
            .post(base + "/safetyUnitEvaluationhz/save", params)
            .then((res) => res.data);
        }
        break;
      case "evalueSubmitHZ":
        {
          return http
            .post(base + "/safetyUnitEvaluationhz/sealAndSubmitHz", params)
            .then((res) => res.data);
        }
        break;
      case "evalueSaveSQ":
        {
          return http
            .post(base + "/safetyUnitEvaluationhz/sealAndSubmitSq", params)
            .then((res) => res.data);
        }
        break;
    }
  },
  //施工企业考评结果公示书、告知书
  resultPublic: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    // params["userId"] = '591746241';
    let nowBase = base + "/safetyUnitEvaluationsp";
    // console.log(JSON.stringify(params))
    switch (method) {
      case "publicList":
        {
          return http
            .post(nowBase + "/selectUnitResultPunlicitykp" + pageInfo, params)
            .then((res) => res.data);
        }
        break;
      case "noticeList":
        {
          return http
            .post(nowBase + "/selectUnitResultInform" + pageInfo, params)
            .then((res) => res.data);
        }
        break;
      //查看详情 电子签章？？暂时没做
      case "queryDetail":
        {
          return http
            .get(nowBase + "/" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
    }
  },
  //企业考评异议复核(搜索)
  dissentReview: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    // params["userId"] = '591746241';
    let nowBase = base + "/safetyUnitEvalObjection";
    // console.log(JSON.stringify(params))
    switch (method) {
      case "queryList":
        {
          return http
            .get(nowBase + "/unitInfos" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "queryDetail":
        {
          return http
            .get(nowBase + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
    }
  },
  //施工企业考评（搜索）
  evalQuery: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/safetyUnitEvaluationhz";
    // console.log(JSON.stringify(params))
    switch (method) {
      case "getData":
        {
          return http
            .get(
              nowBase +
                "/safetyUnitEvaluationhzs" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "evalQueryList":
        {
          return http
            .post(
              base + "/safetyConstructionLicense/unitEvals" + pageInfo,
              params
            )
            .then((res) => res.data);
        }
        break;
      case "unitEvalGatherInfo":
        {
          return http
            .get(
              nowBase +
                "/unitEvalGatherInfo" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "unitEvalApplyInfo":
        {
          return http
            .get(
              nowBase + "/unitEvalApplyInfo" + pageInfo + "/" + parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "relateInfo":
        {
          return http
            .get(
              nowBase +
                "/unitEvalRelateInfo" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "selfEvals":
        {
          return http
            .get(nowBase + "/selfEvals" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "unqualifieds":
        {
          return http
            .get(nowBase + "/unqualifieds" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "accidents":
        {
          return http
            .get(nowBase + "/accidents" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "getActScoreNotices":
        {
          return http
            .get(
              base +
                "/safetyProjectFinishedEvalsp/getActScoreNotices" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
    }
  },
  //撤销企业考评结果（搜索）、公示书、告知书
  revokePublic: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    // params["userId"] = '591746241';
    let nowBase = base + "/safetyUnitEvalRevoke";
    // console.log(JSON.stringify(params))
    switch (method) {
      case "queryList":
        {
          return http
            .get(
              nowBase +
                "/safetyUnitEvalRevokes" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "queryDetail":
        {
          return http
            .get(nowBase + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "publicList":
        {
          return http
            .get(
              nowBase +
                "/revokeResultPublicity" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "decisionList":
        {
          return http
            .get(
              nowBase +
                "/revokeResultInform" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
    }
  },
  //重新申请安全生产标准化考核(登记)、(搜索)  /safetyUnitEvalRepeat/save
  reapplyEval: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    // params["userId"] = '591746241';
    let nowBase = base + "/safetyUnitEvalRepeat";
    // console.log(JSON.stringify(params))
    switch (method) {
      //登记
      case "reapplyNew":
        {
          return http
            .get(nowBase + "/repeatReady" + pageInfo + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "reapplyReady":
        {
          return http
            .get(
              nowBase +
                "/selectUnitevalRepeatReady" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "save":
        {
          return http.post(nowBase + "/save", params).then((res) => res.data);
        }
        break;
      //搜索
      case "reapplyQuery":
        {
          return http
            .post(nowBase + "/unitInfos" + pageInfo, params)
            .then((res) => res.data);
        }
        break;
      case "reapplyDetail":
        {
          return http
            .get(nowBase + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
    }
  },
};

//项目管理
export const Project = {
  listScreenWallByStatus: (type, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    params["limit"]["isMQ"] = "1";
    params["limit"]["queryType"] = type;
    // console.log(JSON.stringify(params))
    return http
      .get(
        base +
          "/screenWall/listScreenWallByStatus" +
          pageInfo +
          "/" +
          parseUrl(params)
      )
      .then((res) => res.data);
  },
  screenWallDelete: (params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    // console.log(JSON.stringify(params));
    {
      return http
        .delete(base + "/screenWall/delete/" + parseUrl(params))
        .then((res) => res.data);
    }
  },
  getByPage: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/tproject";
    //console.log(JSON.stringify(params));
    {
      return http
        .get(nowBase + "/" + method + pageInfo + "/" + parseUrl(params))
        .then((res) => res.data);
    }
  },
  //黑名单人员考勤申报
  blackList: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/blackList";
    //console.log(JSON.stringify(params));
    {
      return http
        .get(nowBase + "/" + method + pageInfo + "/" + parseUrl(params))
        .then((res) => res.data);
    }
  },
  //项目报建及日常管理过程查询
  applications: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/tproject";
    //console.log(JSON.stringify(params));
    {
      return http
        .get(nowBase + "/" + method + pageInfo + "/" + parseUrl(params))
        .then((res) => res.data);
    }
  },
  everyday: (method, pageInfo, params) => {
    let nowBase = base + "/tproject";
    //console.log(JSON.stringify(params));
    {
      return http
        .get(nowBase + "/" + method + pageInfo + "/" + parseUrl(params))
        .then((res) => res.data);
    }
  },
  //    监督部门两个工作事项清单查询
  stochastic: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/tproject";
    //console.log(params);
    {
      return http
        .get(nowBase + "/" + method + pageInfo + "/" + parseUrl(params))
        .then((res) => res.data);
    }
  },
  queryItem: (method, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    //      params["isPubilc"] =1;
    let nowBase = base + "/tproject";
    // console.log(JSON.stringify(params));
    {
      return http
        .get(nowBase + "/" + method + "/" + parseUrl(params))
        .then((res) => res.data);
    }
  },
  project: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/tproject";
    switch (method) {
      case "queryAll": {
        return http
          .get(nowBase + "/getProjectList" + pageInfo + "/" + parseUrl(params))
          .then((res) => res.data);
      }
      case "queryItem":
        {
          return http
            .get(nowBase + "/getProjectInfoDetail/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "getProUint":
        {
          return http
            .get(nowBase + "/getProUnitPersonInfo/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "getPersonInfo":
        {
          return http
            .get(base + "/unitPerson/getPersonInfo/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "item":
        {
          return http
            .get(
              base +
                "/item/findHyItemsByProId" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      //附件黑名单条件
      case "isHaveBlackUnit":
        {
          return http
            .get(base + "/blackList/isHaveBlackUnit/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "initContractNum":
        {
          return http
            .get(base + "/tproject/initContractNum/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "projectNoScoreList":
        {
          return http
            .get(base + "/tproject/projectNoScoreList/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
    }
  },
  //幕墙 params={json类型} , pageInfo="/10/1"
  screenWall: {
    getByPage: (method, pageInfo, params) => {
      let userinfo = JSON.parse(localStorage.userinfo);
      params["userId"] = userinfo.userId;
      params["role"] = userinfo.roleId;
      params["unitId"] = userinfo.unitId;
      // console.log(JSON.stringify(params))
      return http
        .get(base + "/screenWall/" + method + pageInfo + "/" + parseUrl(params))
        .then((res) => res.data);
    },
    queryItem: (method, params) => {
      let userinfo = JSON.parse(localStorage.userinfo);
      params["userId"] = userinfo.userId;
      params["role"] = userinfo.roleId;
      params["unitId"] = userinfo.unitId;
      // console.log(JSON.stringify(params))
      return http
        .get(base + "/screenWall/" + parseUrl(params))
        .then((res) => res.data);
    },
    update: (params) => {
      let userinfo = JSON.parse(localStorage.userinfo);
      params["userId"] = userinfo.userId;
      params["role"] = userinfo.roleId;
      params["unitId"] = userinfo.unitId;
      // console.log(JSON.stringify(params));
      {
        return http
          .post(base + "/screenWall/update", params)
          .then((res) => res.data);
      }
    },
    save: (params) => {
      let userinfo = JSON.parse(localStorage.userinfo);
      params["userId"] = userinfo.userId;
      params["role"] = userinfo.roleId;
      params["unitId"] = userinfo.unitId;
      // console.log(JSON.stringify(params));
      {
        return http
          .post(base + "/screenWall/add", params)
          .then((res) => res.data);
      }
    },
    submit: (params) => {
      //幕墙提交
      let userinfo = JSON.parse(localStorage.userinfo);
      params["userId"] = userinfo.userId;
      params["role"] = userinfo.roleId;
      params["unitId"] = userinfo.unitId;
      // console.log(JSON.stringify(params));
      {
        return http
          .post(base + "/screenWall/submit", params)
          .then((res) => res.data);
      }
    },
    delete: (params) => {
      let userinfo = JSON.parse(localStorage.userinfo);
      params["userId"] = userinfo.userId;
      params["role"] = userinfo.roleId;
      params["unitId"] = userinfo.unitId;
      // console.log(JSON.stringify(params));
      {
        return http
          .delete(base + "/screenWall/delete/" + parseUrl(params))
          .then((res) => res.data);
      }
    },
    batchDelete: (params) => {
      // console.log(params)
      let userinfo = JSON.parse(localStorage.userinfo);
      params["userId"] = userinfo.userId;
      params["role"] = userinfo.roleId;
      params["unitId"] = userinfo.unitId;
      // console.log(JSON.stringify(params));
      {
        return http
          .delete(base + "/screenWall/batchDelete/" + parseUrl(params))
          .then((res) => res.data);
      }
    },
  },
  //危险源
  danger: (method, pageInfo, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    let nowBase = base + "/danger";
    // console.log(JSON.stringify(params));
    //console.log(pageInfo)
    switch (method) {
      case "queryItem":
        {
          return http
            .get(nowBase + "/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "dangerDetails":
        {
          return http
            .get(nowBase + "/dangerDetails/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "selectDangersForPM":
        {
          return http
            .get(
              nowBase +
                "/selectDangersForPM" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "findDangersByStatus":
        {
          return http
            .get(
              nowBase +
                "/findDangersByStatus" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "findDangersByStatusAndRole":
        {
          return http
            .get(
              nowBase +
                "/findDangersByStatusAndRole" +
                pageInfo +
                "/" +
                parseUrl(params)
            )
            .then((res) => res.data);
        }
        break;
      case "update":
        {
          return http.post(nowBase + "/update", params).then((res) => res.data);
        }
        break;
      // 危险源登记 - 保存
      case "add":
        {
          return http.post(nowBase + "/add", params).then((res) => res.data);
        }
        break;
      case "saveOrSubmit":
        {
          return http
            .post(nowBase + "/saveOrSubmit", params)
            .then((res) => res.data);
        }
        break;
      // 危险源登记 - 提交
      case "submitDanger":
        {
          return http
            .post(nowBase + "/submitDanger", params)
            .then((res) => res.data);
        }
        break;
      case "delete":
        {
          return http
            .delete(nowBase + "/delete/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "items": {
        return http
          .get(nowBase + "/items" + pageInfo + "/" + parseUrl(params))
          .then((res) => res.data);
      } //选择单位工程
      case "dangerListByProject":
        {
          return http
            .get(nowBase + "/dangerListByProject/" + parseUrl(params))
            .then((res) => res.data);
        }
        break;
      case "back":
        {
          return http.post(nowBase + "/back", params).then((res) => res.data);
        }
        break;
      case "sendBack":
        {
          return http
            .post(nowBase + "/sendBack", params)
            .then((res) => res.data);
        }
        break;
      case "releaseBack":
        {
          return http
            .post(nowBase + "/releaseBack", params)
            .then((res) => res.data);
        }
        break;
      // 危险源解除 -保存/提交
      case "removeDanger":
        {
          return http
            .post(nowBase + "/removeDanger", params)
            .then((res) => res.data);
        }
        break;
    }
  },
};

//业务字典
const proStatus = [
  { name: "退回", code: "-1" },
  { name: "停止", code: "-10" },
  { name: "完工", code: "-15" },
  { name: "竣工", code: "-20" },
  { name: "在建", code: "30" },
  { name: "删除", code: "-30" },
];
const dbstatus = [
  { name: "全部", code: "" },
  { name: "暂停", code: "-10" },
  { name: "完工", code: "-15" },
  { name: "竣工", code: "-20" },
  { name: "审核通过（在建）", code: "30" },
];
const maius_ProjectStatus = [
  { name: "全部", code: "" },
  { name: "退回", code: "-1" },
  { name: "暂停", code: "-10" },
  { name: "完工", code: "-15" },
  { name: "竣工", code: "-20" },
  { name: "草稿", code: "0" },
  { name: "提交（审核中）", code: "10" },
  { name: "初审通过", code: "20" },
  { name: "审核通过（在建）", code: "30" },
  { name: "危险源计划提交", code: "40" },
  { name: "待确认", code: "5" },
  { name: "竣工提交（审核中）", code: "50" },
  { name: "已确认", code: "6" },
];
const isRandom = [
  { name: "全部", code: "" },
  { name: "是", code: "0" },
  { name: "否", code: "1" },
];
const reqType = [
  { name: "全部", code: "" },
  { name: "施工许可审核", code: "施工许可审核" },
  { name: "项目报建审批", code: "项目报建审批" },
  { name: "记分告知单异议核实", code: "记分告知单异议核实" },
];
const proType = [
  { name: "全部", code: "" },
  { name: "房建工程", code: "01" },
  { name: "市政工程", code: "02" },
  { name: "其他", code: "03" },
];
const proType_ = [
  { name: "房建工程", code: "01" },
  { name: "市政工程", code: "02" },
  { name: "其他", code: "03" },
];
const thisActivityInfo = [
  { name: "全部", code: "" },
  { name: "草稿", code: "0" },
  { name: "审核中", code: "10" },
  { name: "审核通过", code: "30" },
  { name: "退回", code: "-1" },
];
const wfStatus = (status = thisActivityInfo);
const dangerLevel = [
  { name: "全部", code: "" },
  { name: "危险性较大", code: "1" },
  { name: "超过一定规模", code: "2" },
];
const dangerType = [
  { name: "全部", code: "" },
  { name: "基坑工程", code: "10" },
  { name: "建筑边坡工程", code: "20" },
  { name: "模板工程及支撑体系", code: "30" },
  { name: "建筑起重机械", code: "40" },
  { name: "脚手架工程", code: "50" },
  { name: "起重吊装工程", code: "60" },
  { name: "爆破工程", code: "70" },
  { name: "地下暗挖工程", code: "80" },
  { name: "其他危险性大的施工作业活动", code: "90" },
];
const opstatemc = [
  { name: "全部", code: "" },
  { name: "未登记", code: "未登记" },
  { name: "已登记", code: "已登记" },
  { name: "已提交", code: "已提交" },
];
const curquarter = [
  { name: "一季度", code: "1" },
  { name: "二季度", code: "2" },
  { name: "三季度", code: "3" },
  { name: "四季度", code: "4" },
];
const opState = [
  { name: "全部", code: "" },
  { name: "未登记", code: "0" },
  { name: "已登记", code: "5" },
  { name: "提交责任单位盖章", code: "10" },
  { name: "责任单位盖章中", code: "15" },
  { name: "已提交", code: "30" },
];
const totalname = [
  { name: "全部", code: "" },
  { name: "福州市", code: "福州市" },
  { name: "厦门市", code: "厦门市" },
  { name: "泉州市", code: "泉州市" },
  { name: "漳州市", code: "漳州市" },
  { name: "莆田市", code: "莆田市" },
  { name: "宁德市", code: "宁德市" },
  { name: "龙岩市", code: "龙岩市" },
  { name: "三明市", code: "三明市" },
  { name: "南平市", code: "南平市" },
  { name: "平潭综合实验区", code: "平潭综合实验区" },
];
const isover = [
  { name: "全部", code: "" },
  { name: "未逾期", code: "0" },
  { name: "已逾期", code: "1" },
];
const curmonth = [
  { name: "全部", code: "" },
  { name: "1", code: "1" },
  { name: "2", code: "2" },
  { name: "3", code: "3" },
  { name: "4", code: "4" },
  { name: "5", code: "5" },
  { name: "6", code: "6" },
  { name: "7", code: "7" },
  { name: "8", code: "8" },
  { name: "9", code: "9" },
  { name: "10", code: "10" },
  { name: "11", code: "11" },
  { name: "12", code: "12" },
];
const evalresult = [
  { name: "全部", code: "" },
  { name: "优良", code: "优良" },
  { name: "合格", code: "合格" },
  { name: "不合格", code: "不合格" },
];
const evalresultEtp = [
  { name: "全部", code: "" },
  { name: "合格", code: "合格" },
  { name: "基本合格", code: "基本合格" },
  { name: "不合格", code: "不合格" },
];
const area = [
  { name: "全部", code: "" },
  { name: "部许可资质的省属企业", code: "部许可资质的省属企业" },
  { name: "省许可资质的省属企业", code: "省许可资质的省属企业" },
  { name: "中央驻闽企业", code: "中央驻闽企业" },
  { name: "省内其他企业", code: "省内其他企业" },
  { name: "省外入闽企业", code: "省外入闽企业" },
];
const certstate = [
  { name: "全部", code: "" },
  { name: "未登记", code: "未登记" },
  { name: "已登记", code: "已登记" },
  { name: "提交审核", code: "提交审核" },
  { name: "同意受理", code: "同意受理" },
  { name: "不同意受理", code: "不同意受理" },
  { name: "评审中", code: "评审中" },
  { name: "终审通过", code: "终审通过" },
  { name: "终审未通过", code: "终审未通过" },
];
const opstatus = [
  { name: "全部", code: "" },
  { name: "未提交", code: "0" },
  { name: "已提交", code: "1" },
];
const qualLevel = {
  grade: [
    { code: "1", name: "建筑工程施工总承包" },
    { code: "2", name: "市政公用工程施工总承包" },
    { code: "3", name: "地基基础工程专业承包" },
    { code: "4", name: "起重设备安装工程专业承包" },
    { code: "5", name: "预拌混凝土专业承包" },
    { code: "6", name: "电子与智能化工程专业承包" },
    { code: "7", name: "消防设施工程专业承包" },
    { code: "8", name: "防水防腐保温工程专业承包" },
    { code: "9", name: "桥梁工程专业承包" },
    { code: "10", name: "隧道工程专业承包" },
    { code: "11", name: "钢结构工程专业承包" },
    { code: "12", name: "模板脚手架专业承包" },
    { code: "13", name: "建筑装修装饰工程专业承包" },
    { code: "14", name: "建筑机电安装工程专业承包" },
    { code: "15", name: "建筑幕墙工程专业承包" },
    { code: "16", name: "古建筑工程专业承包" },
    { code: "17", name: "城市及道路照明工程专业承包" },
    { code: "18", name: "施工劳务" },
    { code: "19", name: "通信工程施工总承包" },
    { code: "20", name: "环保工程专业承包" },
    { code: "21", name: "公路交通工程（公路安全设施分项）专业承包" },
    { code: "22", name: "公路交通工程（公路机电工程分项）专业承包" },
    { code: "23", name: "港口与航道工程施工总承包" },
  ],
  level: [
    { code: "1", name: "特级" },
    { code: "2", name: "一级" },
    { code: "3", name: "二级" },
    { code: "4", name: "三级" },
    { code: "5", name: "不分等级" },
    { code: "6", name: "不分类别和等级" },
  ],
};
const reportFormType = [
  { name: "全部", code: "" },
  { name: "建设工程主要材料报审表", code: "0" },
  { name: "装配式混凝土结构预制构件报审表", code: "1" },
];
const hy_progress_type = [
  { name: "桩基", code: "1" },
  { name: "基础", code: "2" },
  { name: "主体结构", code: "3" },
  { name: "装饰装修", code: "4" },
  { name: "完工", code: "5" },
  { name: "未开工", code: "6" },
];
const REMAIUS_UPSUPER_TYPE = [
  { name: "省厅督巡查", code: "01" },
  { name: "省站督巡查", code: "02" },
  { name: "市局督巡查", code: "03" },
  { name: "市站督巡查", code: "04" },
  { name: "区/县局督巡查", code: "05" },
];
const remaius_hsStatus = [
  { name: "核实不受理", code: "-1" },
  { name: "无核实异议", code: "0" },
  { name: "核实受理", code: "1" },
  { name: "核实通过", code: "2" },
];
const remaius_fhStatus = [
  { name: "复核不受理", code: "-1" },
  { name: "无复核异议", code: "0" },
  { name: "复核受理", code: "1" },
  { name: "复核通过", code: "2" },
];
const operator_type = [
  { name: "电信", code: "1" },
  { name: "移动", code: "2" },
  { name: "联通", code: "3" },
];
const operator_type_ = [
  { name: "全部", code: "" },
  { name: "电信", code: "1" },
  { name: "移动", code: "2" },
  { name: "联通", code: "3" },
];
const dev_type = [
  { name: "全景成像测距摄像机", code: "1" },
  { name: "普通球型摄像头", code: "101" },
  { name: "固定枪式摄像机", code: "102" },
  { name: "智能测距摄像机", code: "103" },
  { name: "长焦摄像机", code: "104" },
  { name: "可控摄像机", code: "105" },
  { name: "带云台可控枪机", code: "106" },
  { name: "巡航摄像机", code: "107" },
  { name: "无线3G摄像机", code: "109" },
  { name: "加工场摄像机", code: "2" },
  { name: "大门出入口摄像机", code: "3" },
  { name: "吊装设备操作员智能识别设备", code: "4" },
  { name: "塔式起重机超视野摄像机", code: "5" },
  { name: "环境侦测预警联动设备", code: "6" },
];
const domus_jzqzmachine = [
  { name: "施工升降机", code: "30" },
  { name: "塔式起重机", code: "40" },
  { name: "门式起重机", code: "50" },
  { name: "架桥机", code: "60" },
];
const domus_jzqzmachine_ = [
  { name: "全部", code: "" },
  { name: "施工升降机", code: "30" },
  { name: "塔式起重机", code: "40" },
  { name: "门式起重机", code: "50" },
  { name: "架桥机", code: "60" },
];
const domus_investQualLevel = [
  { name: "甲级", code: "1" },
  { name: "乙级", code: "2" },
  { name: "丙级", code: "3" },
];
const CARD_TYPE = [
  { name: "身份证", code: "1" },
  { name: "军官证", code: "2" },
  { name: "护照", code: "3" },
  { name: "台湾居民身份证", code: "4" },
  { name: "香港永久性居民身份证", code: "5" },
  { name: "警官证", code: "6" },
];
const WORK_TYPE = [
  {
    name: "建筑起重机械司机（塔式起重机、施工升降机、安拆工、维修工）",
    code: "416",
  },
  { name: "建筑起重机械信号司索工", code: "170" },
  { name: "建筑架子工", code: "030" },
  { name: "建筑电工", code: "130" },
  { name: "桩工机械", code: "153" },
  { name: "建筑电焊工", code: "270" },
  { name: "高处作业吊篮操作工", code: "032" },
  { name: "安装拆卸工", code: "180" },
];

export const Dictionaries = {
  getDic: (params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    // console.log(JSON.stringify(params));
    return http
      .get(base + "/sysType/getTypeName/" + parseUrl(params))
      .then((res) => res.data);
  },
  query: (name, params) => {
    let userinfo = JSON.parse(localStorage.userinfo);
    params["userId"] = userinfo.userId;
    params["role"] = userinfo.roleId;
    params["unitId"] = userinfo.unitId;
    switch (name) {
      case "safetyFlowLevel": {
        return http
          .get(
            base + "/safetyProjectMonthEval/safetyFlowLevel/" + parseUrl(params)
          )
          .then((res) => res.data);
      }
      case "listUnitQualityAndLevel": {
        return http
          .get(base + "/sysType/listUnitQualityAndLevel/" + parseUrl(params))
          .then((res) => res.data);
      }
      case "getQualLevel": {
        return http
          .get(base + "/sysType/sysTypesByCode/" + parseUrl(params))
          .then((res) => res.data);
      }
    }
  },
  proStatus: proStatus,
  dbstatus: dbstatus,
  isRandom: isRandom,
  reqType: reqType,
  proType: proType,
  proType_: proType_,
  thisActivityInfo: thisActivityInfo,
  wfStatus: wfStatus,
  dangerLevel: dangerLevel,
  dangerType: dangerType,
  opstatemc: opstatemc,
  curquarter: curquarter,
  opState: opState,
  totalname: totalname,
  isover: isover,
  curmonth: curmonth,
  evalresult: evalresult,
  evalresultEtp: evalresultEtp,
  area: area,
  certstate: certstate,
  opstatus: opstatus,
  qualLevel: qualLevel,
  reportFormType: reportFormType,
  hy_progress_type: hy_progress_type,
  REMAIUS_UPSUPER_TYPE: REMAIUS_UPSUPER_TYPE,
  remaius_hsStatus: remaius_hsStatus,
  remaius_fhStatus: remaius_fhStatus,
  operator_type: operator_type,
  operator_type_: operator_type_,
  dev_type: dev_type,
  domus_jzqzmachine: domus_jzqzmachine,
  domus_jzqzmachine_: domus_jzqzmachine_,
  domus_investQualLevel: domus_investQualLevel,
  maius_ProjectStatus: maius_ProjectStatus,
  CARD_TYPE: CARD_TYPE,
  WORK_TYPE: WORK_TYPE,
};



// WEBPACK FOOTER //
// ./src/resources.js